var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41,9H32V7a3,3,0,0,0-3-3H19a3,3,0,0,0-3,3V9H7a5.006,5.006,0,0,0-5,5v4.49a3,3,0,0,0,1,2.227V39a5.006,5.006,0,0,0,5,5H40a5.006,5.006,0,0,0,5-5V20.716a3,3,0,0,0,1-2.226V14A5.006,5.006,0,0,0,41,9ZM18,7a1,1,0,0,1,1-1H29a1,1,0,0,1,1,1V9H18ZM4,14a3,3,0,0,1,3-3H41a3,3,0,0,1,3,3v4.49a1,1,0,0,1-.726.959L28,23.824V23a3,3,0,0,0-3-3H23a3,3,0,0,0-3,3v.824L4.719,19.447A.993.993,0,0,1,4,18.49Zm22,9v4a1,1,0,0,1-1,1H23a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1h2A1,1,0,0,1,26,23ZM40,42H8a3,3,0,0,1-3-3V21.608l15,4.3V27a3,3,0,0,0,3,3h2a3,3,0,0,0,3-3V25.9l15-4.3V39A3,3,0,0,1,40,42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerIcon);
export default __webpack_public_path__ + "static/media/career-icon.71bcc1cf9bfa13b61af3b02ae60c4f79.svg";
export { ForwardRef as ReactComponent };